import { render, staticRenderFns } from "./Messenger.vue?vue&type=template&id=62aa4c5b&scoped=true"
import script from "./Messenger.vue?vue&type=script&lang=js"
export * from "./Messenger.vue?vue&type=script&lang=js"
import style0 from "./Messenger.vue?vue&type=style&index=0&id=62aa4c5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aa4c5b",
  null
  
)

export default component.exports